import { supabase } from './supabase';

// ============================================================================
// TYPES
// ============================================================================

export interface UpgradeScore {
  id: string;
  customer_id: string;
  company_id: string;
  score: number;
  reasoning: any;
}

// ============================================================================
// UPGRADE SCORE CALCULATION
// ============================================================================

export async function calculateUpgradeScores(companyId: string): Promise<void> {
  // Demo implementation: insert a few sample scores for the given company
  const rows = [
    { customer_id: 'cust_001', company_id: companyId, score: Math.floor(60 + Math.random() * 40), reasoning: { factors: ['age', 'usage'] } },
    { customer_id: 'cust_002', company_id: companyId, score: Math.floor(60 + Math.random() * 40), reasoning: { factors: ['service_history'] } },
    { customer_id: 'cust_003', company_id: companyId, score: Math.floor(60 + Math.random() * 40), reasoning: { factors: ['unit_age'] } }
  ];

  const { error } = await supabase.from('upgrade_scores').insert(rows);
  if (error) {
    console.error('Failed to insert upgrade scores', error);
    throw error;
  }
}

// ============================================================================
// UPSELL WORKFLOW ENROLLMENT
// ============================================================================

export async function enrollCustomersInUpsellWorkflows(companyId: string): Promise<void> {
  // Demo implementation: create a placeholder upsell workflow entry
  const { error } = await supabase.from('upsell_workflows').insert({
    name: `Auto Upsell - ${companyId} - ${new Date().toISOString()}`,
    description: 'Automated enrollment triggered from Predictive Maintenance page',
    workflow_id: null
  } as any);

  if (error) {
    console.error('Failed to create upsell workflow', error);
    throw error;
  }
}
